// src/components/store/sections/gallery/GalleryV51PolaroidwallLimeZest.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV51PolaroidwallLimeZest(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={51}
      archKey="polaroid_wall"
      archLabel="Polaroid Washi Wall"
      palName="LimeZest"
      grad="from-lime-500 via-green-500 to-emerald-700"
      lightBg="bg-lime-50"
      textCol="text-lime-800"
      borderCol="border-lime-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#84cc16"
      {...props}
    />
  );
}
